import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { Expose, Transform, Type } from "class-transformer";
import { FileDto } from "@/core/features/file/file.dto";
import { parseApiDate } from "@/utils/dates/dateFormats";
import { setTimeToMidday, toLocaleTimezone } from "@/utils/dates/dateUtils";

export class UserChangeHolidayDto extends BaseEntityDto {
  @Expose()
  userId: string;

  @Expose()
  collectiveAgreementHolidayId: string;

  @Expose()
  @Transform(({ value }) => setTimeToMidday(toLocaleTimezone(parseApiDate(value))))
  newDate: Date;

  @Expose()
  fileId?: string | null;

  @Expose()
  @Type(() => FileDto)
  file?: FileDto | null;
}
